//apifetch
import axios from 'axios';

//translate
import i18n from '../../translate/i18n';

//type
import { imagesReadyForDeliveryRequestType } from './type/BookingType';

//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;


export const PostPrepareCheckinApi = async (id: number, data:imagesReadyForDeliveryRequestType) => {
  const token = localStorage.getItem("token");
  console.log("data", data)
  try {
    const response = await axios.post(`${baseURL}/booking/${id}/prepare-checkin`, data, {
      headers: {
      "Content-Type": "multipart/form-data",
      'Accept-Language': i18n.language,
      Authorization: `Bearer ${token}`,
      },
    }); 
    return response.data;
  } catch (error: any) {
    console.error(error.response?.data || error.message);
    throw error;
  }
};